import { Firestore, doc, setDoc } from '@angular/fire/firestore';
import { Auth } from '@angular/fire/auth';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { PushNotifications, Token, ActionPerformed } from '@capacitor/push-notifications';
import { TrackingService } from './tracking.service';
import { getDoc } from '@angular/fire/firestore';
@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  private router = inject(Router);

  constructor(private firestore: Firestore, private auth: Auth, public trackingS: TrackingService) {}

  initPush() {
    //console.log('Initializing push notifications...');

    if (Capacitor.isNativePlatform()) {
      this.updatePushTokenOnAppStart();
      this.registerPush();
    } else {
      //console.log('Push notifications not supported on this platform');
    }
  }

  // private registerPush() {
  //   // Solicitar permisos
  //   PushNotifications.requestPermissions().then(async (permission) => {
  //     if (permission.receive === 'granted') {
  //       await PushNotifications.register();
  //     } else {
  //       console.warn('Push permission not granted');
  //     }
  //   });

  private async registerPush() {
    // Paso 1: Solicita permiso al usuario
    const permission = await PushNotifications.requestPermissions();
    if (permission.receive !== 'granted') {
      console.warn('❌ Permiso para notificaciones no concedido');
      return;
    }

    // ⚠️ Paso 2: Forzamos obtener un nuevo token cada vez
    PushNotifications.addListener('registration', async (token: Token) => {
      //console.log(' Token forzado obtenido:', token.value);

      // 👉 Elimina el token anterior en Firestore (opcional)
      await this.clearPreviousTokenInFirestore();

      // ✅ Guarda el nuevo token en Firestore
      await this.savePushTokenToFirestore(token.value);
    });

    // Paso 3: Registra el dispositivo (esto dispara el listener anterior)
    await PushNotifications.register();

    // Maneja error en el registro
    PushNotifications.addListener('registrationError', (error: any) => {
      console.error(' Error al registrar push:', JSON.stringify(error));
    });

    // Manejo de notificación al hacer clic
    PushNotifications.addListener('pushNotificationActionPerformed', (notification: ActionPerformed) => {
      //console.log(' Notificación clickeada:', notification);
      const data = notification.notification.data;
      this.trackingNotification(notification);
      if (data?.target === 'home') {
        this.router.navigate(['/home'], { queryParamsHandling: 'preserve' });
      } else {
        this.router.navigate(['/home'], { queryParamsHandling: 'preserve' });
      }
    });
  }

  private async clearPreviousTokenInFirestore() {
    const currentUser = this.auth.currentUser;

    if (currentUser) {
      const userRef = doc(this.firestore, `users/${currentUser.uid}`);
      await setDoc(
        userRef,
        { pushTokenNative: null }, // elimina explícitamente el anterior
        { merge: true }
      );
      //console.log(' Token anterior eliminado de Firestore');
    } else {
      console.warn(' No hay usuario autenticado para eliminar token anterior');
    }
  }

  private async updatePushTokenOnAppStart() {
    const permission = await PushNotifications.requestPermissions();
    if (permission.receive !== 'granted') {
      console.warn('❌ Permiso para notificaciones no concedido');
      return;
    }

    // ✅ Pedimos el token actual directamente
    PushNotifications.addListener('registration', async (token: Token) => {
      //console.log(' Token actualizado al abrir la app:', token.value);
      await this.savePushTokenToFirestore(token.value); // reemplaza el anterior
    });

    // 🔁 Siempre pedimos que registre para forzar evento de 'registration'
    await PushNotifications.register();
  }

  async savePushTokenToFirestore(token: string) {
    const currentUser = this.auth.currentUser;

    if (currentUser) {
      const userRef = doc(this.firestore, `users/${currentUser.uid}`);
      await setDoc(
        userRef,
        { pushTokenNative: token },
        { merge: true } // no borra otros datos del usuario
      );
      //console.log('Token guardado en Firestore ');
    } else {
      //console.warn('No hay usuario autenticado para guardar token ');
    }
  }

  trackingNotification(notification: any) {
    this.trackingS.trackEvent(
      'push_notification_received',
      {
        notification_id: notification.notification.id,
        notification_type: notification.actionId, // ¿?
      },
      false,
      false
    );
  }

  async ensurePushTokenExists() {
    const currentUser = this.auth.currentUser;

    if (!currentUser || !Capacitor.isNativePlatform()) return;

    const userRef = doc(this.firestore, `users/${currentUser.uid}`);
    const userSnap = await getDoc(userRef);

    const userData = userSnap?.data();

    if (!userData?.['pushToken']) {
      //console.log(' Usuario sin pushToken, solicitando...');

      const permission = await PushNotifications.requestPermissions();
      if (permission.receive !== 'granted') {
        console.warn('Permiso de notificación no otorgado');
        return;
      }

      await PushNotifications.register();

      PushNotifications.addListener('registration', async (token: Token) => {
        //console.log('Token obtenido:', token.value);
        await this.savePushTokenToFirestore(token.value);
      });
    } else {
      //console.log('Usuario ya tiene pushToken registrado');
    }
  }
}
